import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import CancellationHeader from "../../../components/cancellation/CancelationHeader";
import CancelPackageButton from "../../../components/package/CancelPackageButton";
import BookingDetails from "../../../components/shared/bookingDetails";
import Header from "../../../components/shared/header";
import useTitle from "../../../hooks/useTitle";

import { extractPackageCancellationDetails } from "../../../Utils/extract";
import { PackageCancellationWrapper } from "./style";

interface IProps {
  title: string;
}

const PackageCancellation: React.FC<IProps> = ({ title }) => {
  useTitle(title);
  const [searchParams] = useSearchParams();

  const { numOfSessions, price, packageCode, companyId, companyName } =
    extractPackageCancellationDetails(searchParams);

  return (
    <PackageCancellationWrapper>
      <Header headerLabel="Cancel Package" />
      <BookingDetails
        details={[
          {
            items: [
              {
                label: "Company",
                value: companyName,
              },
              {
                label: "Package Code",
                value: packageCode,
              },
            ],
          },
          {
            items: [
              {
                label: "Package Credits",
                value: numOfSessions,
              },
              {
                label: "Price",
                value: price,
              },
            ],
          },
        ]}
      />
      <CancelPackageButton companyId={companyId} packageCode={packageCode} />
    </PackageCancellationWrapper>
  );
};

export default PackageCancellation;
